<template>
    <Modal :display="true" :showAcceptButton="false" :showDeclineButton="false" :showCloseXButton="false" class="dialog-preview">
        <DocumentSigner v-if="publicStore.docSign.loaded" :url="publicStore.docSign.url" frameBorder="0"/>
    </Modal>
  </template>
<script setup lang="ts">
    import DocumentSigner from "@components/document-signer.vue";
    import Modal from "@/app/components/modal.vue";
    import { usePublicStore } from "@publicstore/store";

    const props = defineProps({
        type: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        }
    });

    const publicStore = usePublicStore();
    publicStore.loadSignatureInfo(props.type, props.id);
</script>